/**
 *  VR带看 顾问端Service
 */
import eventBus from '@/services/eventBus.service';
import layerManager from '@/services/layer.manager';
import vrShowApi from '@/apis/vr.show.api';
import VRICSAppService from './vr.ics.app.service.js';
import StateListenService from './state.listen.service';
import vrUtil from './vr.utils';
import Emitter from 'tiny-emitter';
import { rtcTracker, nodeNames } from './rtc.tracker.js';
import { IcsEncrySalesError, UserInfoError } from './exception.js';
import { isHeigherIcsAppVersionNum } from '@/services/vrShow/vr.show.loader';

export default class SalerEndService extends Emitter {
  constructor() {
    super();
    this.vrICSAppService = new VRICSAppService();
    this.role = 2;
    this.channelName = '';
    this.setIntervalHearBeat = null;
    this.getEncrysalesPromise = null;
    this.toastMillisec = 3000; // toast显示时长
    this.millisec = 1000; // 心跳时长
    this.phoneState = 0;
    this.encrysalesInfo = null;
    this.getEmitOpenSpeakerState();
    this.isShowSpeakerButtonState = false;
  }
  /**
   * 获取ics端顾问加密串
   * @returns
   */
  getEncrysales() {
    rtcTracker.log(nodeNames.getIcsEncryptedStr);
    if (!this.getEncrysalesPromise) {
      this.getEncrysalesPromise = this.vrICSAppService.getEncrysales();
    }
    return this.getEncrysalesPromise.catch((ex) => {
      return Promise.reject(new IcsEncrySalesError(ex));
    });
  }
  /**
   * 获取c端用户信息
   * @param {*} encryptedInfo
   * @returns
   */
  getUserInfo(encryptedInfo) {
    rtcTracker.log(nodeNames.getUserInfo, this.channelName);
    return vrShowApi
      .getUserInfo({
        encryptedInfo: encryptedInfo,
      })
      .then(function (res) {
        if (res.returncode !== 0) {
          return Promise.reject(new UserInfoError(res));
        }
        return res;
      })
      .catch((ex) => {
        return Promise.reject(new UserInfoError(ex));
      });
  }
  /**
   *  获取客户信息
   * @returns
   */
  initUser() {
    return this.getEncrysales()
      .then((encrysales) => {
        console.warn('initUserEncrysales=> ', encrysales);
        this.encrysalesInfo = encrysales;
        return this.getUserInfo(encrysales.encrysalesid);
      })
      .then((res) => {
        this.channelName = res.result.channelName;
        this.channelId = res.result.channelId;

        // 上报到页面B端获取顾客
        if (res.result && res.result.user) {
          eventBus.$emit('adviser', {
            userInfo: res.result.user,
            salesInfo: res.result.adviser,
            channelId: res.result.channelId,
            channelName: res.result.channelName,
          });
        }
        // 心跳开始的地方
        this.heartBeatFromHere();
        return Promise.resolve({
          channelId: res.result.channelId,
          channelName: res.result.channelName,
        });
      });
  }
  /**
   * 处理接听错误
   * @param {*} error
   */
  processError(error) {
    this.showError(error);
    let node = {};
    if (error instanceof IcsEncrySalesError) {
      node = nodeNames.getIcsEncryptedStr;
    } else if (error instanceof UserInfoError) {
      node = nodeNames.getUserInfo;
    } else {
      node = nodeNames.unknown;
    }
    rtcTracker.error(node, error, this.channelName);
    this.hangUpIcs({
      node: nodeNames.processError,
      extend: {
        node,
        channelName: this.channelName,
      },
    });
  }
  /**
   * 开始心跳
   */
  heartBeatFromHere() {
    this.setIntervalHearBeat = setInterval(() => {
      this.hearBeatEvent();
    }, this.millisec);
  }
  /**
   * 心跳请求处理
   * @returns
   */
  async hearBeatEvent() {
    const [error, res] = await vrUtil.asyncThorwFunction(
      vrShowApi.heartBeatListen({
        channelName: this.channelName,
        role: this.role,
      }),
    );
    if (error) {
      return false;
    }
    if (res.returncode !== 0) {
      return false;
    }
    const {
      result: { state },
    } = res;
    if (state) {
      this.stateListen(state);
    }
  }
  // 状态提醒
  stateListen(state) {
    // 状态没变更不监听
    if (vrUtil.compareState('s', state)) {
      return false;
    }
    // 对方app状态不监控
    if ([166, 160, 163, 168, 130].includes(state)) {
      return false;
    }
    let stateListenService = new StateListenService(state);
    const backState = stateListenService.getState();
    if (backState) {
      // 上报到页面的通话状态
      if (backState.callingState) {
        this.phoneState = backState.callingState;
      }
      // 状态提醒后
      if (backState.toastText) {
        if (backState.stateCode) {
          // 不断开通话链接
          layerManager.toast(
            { propsData: { message: backState.toastText } },
            this.toastMillisec,
          );
        } else {
          // 断开通话链接（两个时长（this.toastMillisec）保持一致，防止提示还未关闭，通话已结束）
          layerManager.toast(
            { propsData: { message: backState.toastText } },
            this.toastMillisec,
          );
          this.hangUpIcs({
            node: nodeNames.stateListen,
            extend: {
              state,
            },
          });
        }
      }
    }
    stateListenService = null;
  }
  // 是否显示扬声器按钮
  isShowSpeakerButton() {
    const icsVersion = this.encrysalesInfo?.appversion;
    this.isShowSpeakerButtonState = isHeigherIcsAppVersionNum(icsVersion);
    return this.isShowSpeakerButtonState;
  }
  // 接听开始啦
  receive() {
    rtcTracker.start('sales');
    this.setIntervalHearBeat = null;
    eventBus.$emit('startHome');
    return this.initUser()
      .then((data) => {
        this.isShowSpeakerButton() && this.getOpenSpeakerState();
        return data;
      })
      .catch(this.processError.bind(this));
  }
  getOpenSpeakerState() {
    this.vrICSAppService.isOpenSpeaker();
  }
  // 对声网扬声器状态的监听
  getEmitOpenSpeakerState() {
    eventBus.$on('runIsOpenSpeaker', (data) => {
      let stateListenService = new StateListenService(data.state);
      const souneState = stateListenService.getTransformState();
      console.log({
        顾问端监听到的声器状态: souneState,
      });
      eventBus.$emit('isOpenSpeaker', { souneState });
      stateListenService = null;
    });
  }
  switchSpeaker(isOPen) {
    try {
      this.vrICSAppService.switchSpeaker(!isOPen);
      return Promise.resolve();
    } catch (ex) {
      return Promise.reject(ex);
    }
  }
  //创建新建ics容器webview参数
  icsSetNewWebView(params) {
    const paramsSting = JSON.stringify(params);
    this.vrICSAppService.icsSetNewWebView(paramsSting);
  }
  // 主动挂断语音
  hangUpIcs({ node, extend }) {
    rtcTracker.hangUpIcsLog(node, extend);
    eventBus.$emit('endHome');
    this.vrICSAppService.hangUpIcs();
    this.phoneState = 0;
    if (this.setIntervalHearBeat) {
      clearInterval(this.setIntervalHearBeat);
    }
  }
  // 获取异常提示
  showError(res) {
    console.warn('获取异常提示==> ', res);
    let message = '';
    if (res && res.message) {
      message = res.message;
    } else {
      message = '当前网络不佳，请稍后重试';
    }
    layerManager.toast({ propsData: { message } }, this.toastMillisec);
  }
}
